import { CSSProperties } from "react";

const mtStyles = {
  mt1: { marginTop: 1 },
  mt2: { marginTop: 2 },
  mt3: { marginTop: 3 },
};

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "100vw",
    height: "94vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
  },
  box: {
    width: 300,
    padding: 4,
    borderRadius: 2,
    backgroundColor: "#fff",
  },
  labelFlex: {
    display: "flex",
    ...mtStyles.mt2,
  },
  input: {
    ...mtStyles.mt1,
  },
  button: {
    ...mtStyles.mt3,
  },
  back: {
    ...mtStyles.mt2,
  },
};
